import BaseComponent from "../../../baseComponent.js";
import Expression from "./expression.jsx";
import styles from "./styles.scss";

export default class TextualConfig extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.legendConfig} name="legendConfig">
        <div className={styles.legendConfigContent}>
          <Expression label="Data"
                      expressionKey="y"
                      widgetId={this.props.widgetId}
                      legendId={this.props.legend.id}
                      onLegendChange={this.props.onLegendChange}
                      expression={this.props.legend.expressions.y}
                      mappings={this.props.legend.mappings}
                      callback={this.props.callback}
                      subscribedDataset={this.props.subscribedDataset}/>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/textualConfig.jsx